/**
 * Password Reset Popup Functionality
 * Handles opening and closing the password reset popup
 */
document.addEventListener('DOMContentLoaded', function() {
  // Get necessary elements
  const forgotPasswordLink = document.querySelector('.forgot-password-link');
  const changePasswordLink = document.querySelector('a[class*="ai-customer-account__change-password"]');
  const resetPasswordPopup = document.getElementById('halo-reset-password-popup');
  const resetPasswordCloseButton = document.querySelector('.reset-password-top-close-button');
  const resetPasswordBackButton = document.querySelector('.reset-password-back-button');
  const resetPasswordOverlay = document.querySelector('.reset-password-popup-overlay');
  const resetPasswordWrapper = document.querySelector('.reset-password-popup-wrapper');
  const resetPasswordForm = document.getElementById('recover_customer_password');

  // Get notification elements
  const successNotification = document.querySelector('.reset-success-notification');
  const errorNotification = document.querySelector('.reset-error-notification');

  // Function to open the reset password popup
  function openResetPasswordPopup(event) {
    if (event) {
      event.preventDefault();
    }

    // Reset form and hide notifications when opening
    if (resetPasswordForm) {
      const emailInput = resetPasswordForm.querySelector('#recover-email');
      if (emailInput) {
        emailInput.value = '';
      }
    }

    // Hide notifications
    if (successNotification) {
      successNotification.style.display = 'none';
    }
    if (errorNotification) {
      errorNotification.style.display = 'none';
    }

    // Forcefully close the login sidebar
    document.body.classList.remove('auth-sidebar-show');

    // Force the login sidebar to hide with inline style
    const loginSidebar = document.getElementById('halo-auth-sidebar');
    if (loginSidebar) {
      loginSidebar.style.display = 'none';
    }

    // Short delay to ensure the sidebar is closed
    setTimeout(() => {
      // Apply the background color to the reset password popup
      if (resetPasswordPopup) {
        resetPasswordPopup.style.backgroundColor = 'rgba(35, 35, 35, 0.8)';
      }

      // Open the reset password popup
      resetPasswordPopup.classList.add('is-visible');
      // document.body.classList.add('body-overflow-hd');

      // Reset the sidebar display style after it's fully closed and popup is shown
      if (loginSidebar) {
        loginSidebar.style.removeProperty('display');
      }
    }, 300);
  }

  // Function to close the reset password popup
  function closeResetPasswordPopup() {
    // Hide the popup
    resetPasswordPopup.classList.remove('is-visible');
    document.body.classList.remove('body-overflow-hd');

    // Hide any notifications that might be visible
    if (successNotification) {
      successNotification.style.display = 'none';
    }
    if (errorNotification) {
      errorNotification.style.display = 'none';
    }

    // Reset the form if it exists
    if (resetPasswordForm) {
      const emailInput = resetPasswordForm.querySelector('#recover-email');
      if (emailInput) {
        emailInput.value = '';
      }

      // Re-enable the form's submit button just in case it was disabled
      const submitButton = resetPasswordForm.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = false;
      }
    }
  }

  // Override the click event on the forgot password link
  if (forgotPasswordLink) {
    // Remove any existing event listeners by cloning the element
    const newForgotPasswordLink = forgotPasswordLink.cloneNode(true);
    forgotPasswordLink.parentNode.replaceChild(newForgotPasswordLink, forgotPasswordLink);

    // Add the new click event listener
    newForgotPasswordLink.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      openResetPasswordPopup(event);
      return false;
    });
  }

  if (resetPasswordCloseButton) {
    resetPasswordCloseButton.addEventListener('click', closeResetPasswordPopup);
  }

  if (resetPasswordBackButton) {
    resetPasswordBackButton.addEventListener('click', closeResetPasswordPopup);
  }

  // Close popup when clicking anywhere outside the popup wrapper
  if (resetPasswordPopup) {
    resetPasswordPopup.addEventListener('click', function(event) {
      // If the click is directly on the popup (outside the wrapper)
      // but not on the wrapper itself, close the popup
      if (event.target === resetPasswordPopup && !resetPasswordWrapper.contains(event.target)) {
        closeResetPasswordPopup();
      }
    });
  }

  if (resetPasswordOverlay) {
    resetPasswordOverlay.addEventListener('click', closeResetPasswordPopup);
  }

  // Set up reset password form event handler
  if (resetPasswordForm) {
    resetPasswordForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Get and validate email
      const emailInput = this.querySelector('#recover-email');
      const email = emailInput.value.trim();
      if (!email) {
        showErrorNotification();
        return false;
      }

      // Store submission details for analytics
      if (window.Shopify && window.Shopify.recaptchaV3) {
        window.Shopify.recaptchaV3.addToken(resetPasswordForm, 'recover_customer_password');
      }

      // Create form data for submission
      // Get the submit button and disable it during submission
      const submitButton = resetPasswordForm.querySelector('button[type="submit"]');
      let originalButtonText = '';
      let loadingTimeout;

      if (submitButton) {
        // Save original button text
        originalButtonText = submitButton.innerHTML;

        // Change button text to loading state
        submitButton.innerHTML = '<span>กำลังส่ง...</span>';
        submitButton.disabled = true;

        // Set a timeout to revert the button if the request takes too long
        loadingTimeout = setTimeout(() => {
          submitButton.innerHTML = originalButtonText;
          submitButton.disabled = false;
        }, 10000); // 10 seconds timeout
      }

      // สร้าง URL-encoded form string แบบมาตรฐาน
      const formParams = new URLSearchParams();
      formParams.append('form_type', 'recover_customer_password');
      formParams.append('utf8', '✓');
      formParams.append('email', email);

      console.log('FetchForgot!!!', )
      // Submit form via fetch - ใช้ URLSearchParams แทน FormData
      fetch('/account/recover', {
        method: 'POST',
        body: formParams.toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': '*/*'
        }
      })
      .then(response => {
        // Show success notification regardless of response
        // (Shopify always returns success for security reasons)
        console.log('ResponsForgotPassword::', response)
        showSuccessNotification();
        emailInput.value = ''; // Clear email field

        // Re-enable the submit button and restore original text
        const submitButton = resetPasswordForm.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.innerHTML = originalButtonText;
          submitButton.disabled = false;
        }

        // Clear any existing timeouts
        if (loadingTimeout) {
          clearTimeout(loadingTimeout);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        showErrorNotification();

        // Re-enable the submit button on error and restore original text
        const submitButton = resetPasswordForm.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.innerHTML = originalButtonText;
          submitButton.disabled = false;
        }

        // Clear any existing timeouts
        if (loadingTimeout) {
          clearTimeout(loadingTimeout);
        }
      });

      // Return false to ensure the form doesn't submit
      return false;
    });
  }

  // Check if the URL has a reset_password=true parameter, and if so open the popup
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('reset_password') === 'true') {
    openResetPasswordPopup();
  }

  // Show success notification function
  function showSuccessNotification() {
    if (successNotification) {
      successNotification.style.display = 'block';

      // Center the notification
      centerNotification(successNotification);

      // Auto hide after 4 seconds
      setTimeout(() => {
        successNotification.style.display = 'none';
        closeResetPasswordPopup();
      }, 4000);
    }
  }

  // Show error notification function
  function showErrorNotification() {
    if (errorNotification) {
      errorNotification.style.display = 'block';

      // Center the notification
      centerNotification(errorNotification);

      // Auto hide after 4 seconds
      setTimeout(() => {
        errorNotification.style.display = 'none';
      }, 4000);
    }
  }

  // Helper function to center notifications
  function centerNotification(notification) {
    const viewportWidth = window.innerWidth;
    const notificationWidth = notification.offsetWidth;
    const leftPosition = (viewportWidth - notificationWidth) / 2;

    notification.style.left = leftPosition + 'px';
  }

  // Handle all change password links with data attribute
  const allChangePasswordLinks = document.querySelectorAll('[data-open-reset-password], a[class*="ai-customer-account__change-password"]');

  if (allChangePasswordLinks.length > 0) {
    allChangePasswordLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        openResetPasswordPopup(event);
      });
    });
  }
});
